module.exports = "mat-hint {\n  color: red; }\n"